// extracted by mini-css-extract-plugin
module.exports = {"burgerIngredientsSection":"burger-ingredients_burgerIngredientsSection__18vf4"};